import { render, staticRenderFns } from "./HeaderRegister2.vue?vue&type=template&id=f98d499e&scoped=true"
import script from "./HeaderRegister2.vue?vue&type=script&lang=ts"
export * from "./HeaderRegister2.vue?vue&type=script&lang=ts"
import style0 from "./HeaderRegister2.vue?vue&type=style&index=0&id=f98d499e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f98d499e",
  null
  
)

export default component.exports